import * as React from 'react';
import { TooltipContent } from '../../components/Notification/TooltipContent';
import { CustomTooltip } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { selectSavedInFolders, selectSavedOfferId, selectUserHasFolders } from '../../selectors';
import { getTextCount } from '../../utils/folders';
import { FolderName } from '../../components/Notification/FolderName';
import { hideNotification } from '../../actions';
import { CreateFolderButtonContainer } from '../CreateFolderButtonContainer';
import { ChangeFolderButtonContainer } from '../ChangeFolderButtonContainer';
var FAVORITES_URL = 'https://cian.ru/favorites';
export function TooltipContainer(_ref) {
  var buttonRef = _ref.buttonRef,
      placement = _ref.placement,
      onClickFolderName = _ref.onClickFolderName;
  var dispatch = useDispatch(); // eslint-disable-next-line

  var offerIds = useSelector(selectSavedOfferId);
  var savedInFolders = useSelector(selectSavedInFolders);
  var userHasFolders = useSelector(selectUserHasFolders);
  var button = null;

  if (offerIds.length <= 1 && !savedInFolders && !userHasFolders) {
    button = /*#__PURE__*/React.createElement(CreateFolderButtonContainer, {
      showIcon: true
    });
  } else if (offerIds.length <= 1) {
    button = /*#__PURE__*/React.createElement(ChangeFolderButtonContainer, {
      showIcon: true
    });
  }

  var handleClickName = function handleClickName() {
    if (savedInFolders && onClickFolderName) {
      onClickFolderName(savedInFolders[0].id);
    }
  };

  var description;

  if (savedInFolders && savedInFolders.length === 0) {
    description = /*#__PURE__*/React.createElement("div", null, "\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u043A");
  } else if (!savedInFolders) {
    description = /*#__PURE__*/React.createElement("div", null, "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435");
  } else {
    var spanText = savedInFolders.length > 1 ? getTextCount(savedInFolders.length) : "\xAB".concat(savedInFolders[0].name, "\xBB");
    description = /*#__PURE__*/React.createElement("div", null, "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E \u0432", /*#__PURE__*/React.createElement(FolderName, {
      folderUrl: savedInFolders && savedInFolders.length === 1 ? "".concat(FAVORITES_URL, "?folder=").concat(savedInFolders[0].id) : '',
      text: spanText,
      onClick: handleClickName
    }));
  }

  return /*#__PURE__*/React.createElement(CustomTooltip, {
    content: /*#__PURE__*/React.createElement(TooltipContent, {
      description: description,
      button: button
    }),
    outside: true,
    anchorRef: buttonRef,
    arrow: true,
    portal: true,
    open: true,
    theme: "black",
    placement: placement ? placement : 'bottom-start',
    flip: false,
    preventOverflow: false,
    maxWidth: 400,
    onClose: function onClose() {
      return dispatch(hideNotification());
    }
  });
}